// extracted by mini-css-extract-plugin
module.exports = {"lds_ripple":"spinner_lds_ripple__7OIK3","lds-ripple":"spinner_lds-ripple__1lh3j"};